<template>
  <div>
    <yd-popup v-model="isPageShow" position="center" width="100%" :close-on-masker="false">
      <div class="common-popup-type">
        <img v-show="imgUrl" height="80" style="opacity: 0.90;padding-left: 24px;display: block;margin: 0 auto;margin-bottom: 10px;" :src="imgUrl" alt=""/>
        <div class="tip-str">
          <p>{{title}}</p>
        </div>
        <div class="select-type-box clearfix">
          <div :class="['tab',activeIndex==1?'active':'']" @click="onLeftChange">{{leftTitle}}</div>
          <div :class="['tab',activeIndex==2?'active':'']" @click="onRightChange">{{rightTitle}}</div>
        </div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
export default {
  name: 'commonPopup',
  props: {
    title: String,
    imgUrl:String,
    leftTitle: String,
    rightTitle: String,
    activeIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isPageShow:false
    }
  },
  methods: {
    onLeftChange() {
      this.$emit('leftChange')
    },
    onRightChange() {
      this.$emit('rightChange')
    }
  }
}
</script>

<style lang="less" scoped>
  .common-popup-type {
    width: 84%;
    padding: 30px 10px 38px 10px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 5px;
  }
  .tip-str {
    font-size: 15px;
    line-height: 21px;
    color: #303030;
    text-align: center;
    display: block;
    padding: 0px 10px;
  }
  .select-type-box {
    width: 100%;
    margin: 0px auto;
    margin-top: 50px;
  }
  .tab {
    display: block;
    width: 49%;
    height: 43px;
    float: left;
    line-height: 43px;
    text-align: center;
    border-radius: 22px;
    margin-right: 2%;
    background-color: #E4E4E4;
    color: #303030;
    font-weight: 600;
  }
  .tab:last-child {
    margin-right: 0%;
  }
  .tab:hover,.tab:active,.active{
    background-color: #3377ff;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/modules/commonPopup/index.vue